














import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    donutSeries() {
      return [
        this.$store.getters.badResolutionList.length,
        this.$store.getters.totalDataNumber -
          this.$store.getters.badResolutionList.length,
      ];
    },
    heatSeries() {
      const resolutionDistribution = this.$store.getters.resolutionDistribution;

      const widthBins = resolutionDistribution.wbins;
      const widthMin = resolutionDistribution.wmin;
      const valuesMat = resolutionDistribution.values;

      const computedHeatSeries: Array<{ name: string; data: Array<number> }> =
        [];

      let idx = 0;
      valuesMat.forEach((row: Array<number>) => {
        idx++;
        computedHeatSeries.push({
          name: `~${widthMin + widthBins * idx}`,
          data: row,
        });
      });

      return computedHeatSeries;
    },
    heatmapChartOptions(): ApexOptions {
      const resolutionDistribution = this.$store.getters.resolutionDistribution;

      const heigthBins = resolutionDistribution.hbins;
      const heightMin = resolutionDistribution.hmin;

      const categories = [];
      for (let idx = 0; idx < 10; idx++) {
        categories.push(`~${heightMin + heigthBins * (idx + 1)}`);
      }
      return {
        chart: {
          type: 'heatmap',
          toolbar: {
            show: false,
          },
          offsetY: 0,
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#fff'],
          },
        },
        xaxis: {
          type: 'category',
          categories: categories,
        },
        fill: {
          opacity: 0.8,
        },
        colors: ['#24BE99'],
        noData: {
          text: '모든 데이터가 해상도 기준을 만족합니다',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '20px',
            fontFamily: 'Noto Sans KR',
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          heatmap: {
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: '#dddddd',
                },
              ],
            },
          },
        },
      };
    },
  },
  data(): {
    donutLabels: string[];
    donutColors: string[];
  } {
    return {
      donutLabels: ['준수', '미준수'],
      donutColors: ['#24BE99', '#F8791D'],
    };
  },
});
